import { Link } from "react-router-dom"

import { CALL_PAGE } from "../common/constants"

import { Text } from "ui-kit/components-branded/index"
import { createPsyCallPath } from "modules/Call/routing"
import { CallStatus } from "modules/Call/queries"
import { AccessDevices } from "modules/Call/components/AccessDevices"
import { GoToCallButton } from "modules/Call/components/GoToCallButton"
import { InfoCard, SessionInfo, InstructionsPopup } from "modules/Call/components/index"

interface Props {
    clientName: string
    sessionDatetime: string
    sessionDuration: number
    clientId: number
    hasQuestionnaireAnswers: boolean
    bookingHash: string
    callStatus: CallStatus
    companionLocation: CALL_PAGE
}

export function LobbyInfoForPsy({
    clientName,
    sessionDatetime,
    sessionDuration,
    clientId,
    hasQuestionnaireAnswers,
    bookingHash,
    callStatus,
    companionLocation,
}: Props) {
    return (
        <InfoCard
            content={
                <>
                    <div className="info-card__header">
                        Подготовьтесь к&nbsp;сессии с&nbsp;клиентом{" "}
                        <InstructionsPopup>по&nbsp;инструкции</InstructionsPopup>
                    </div>
                    <AccessDevices />
                    <hr className="is-hidden-mobile mgt-1 mgb-3" />
                    <hr className="is-hidden-tablet mgt-3 mgb-3" />
                    <SessionInfo
                        sessionDatetime={sessionDatetime}
                        sessionDuration={sessionDuration}
                    />
                    <hr className="mgt-3 mgb-3" />
                    <div>
                        <Text>
                            Ваш клиент: {clientName}{" "}
                            {companionLocation === CALL_PAGE.ROOM && (
                                <>
                                    <span className="color-alter-white-30">•</span>уже на звонке
                                </>
                            )}
                            {hasQuestionnaireAnswers && (
                                <>
                                    <br />
                                    <Link
                                        to={`/psychologist-account/clients/${clientId}`}
                                        target="_blank"
                                        className="link-secondary"
                                    >
                                        Посмотреть анкету клиента
                                    </Link>
                                </>
                            )}
                        </Text>
                    </div>
                </>
            }
            footer={
                <GoToCallButton
                    callLink={createPsyCallPath(`/room/${bookingHash}`)}
                    callStatus={callStatus}
                />
            }
        />
    )
}
